import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Features from './components/Features';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="https://public.readdy.ai/ai/img_res/6db6d4e6-87fa-46b4-8c7e-e3bfc96e3d8e.png" alt="OGIN d.o.o." className="h-10 w-10 object-contain" />
            <span className={`text-lg font-medium transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>OGIN d.o.o.</span>
          </div>
          <div className="flex items-center gap-10">
            <a href="#home" className={`text-sm font-light transition-colors hover:opacity-80 ${scrolled ? 'text-gray-700' : 'text-white/90'}`}>Home</a>
            <a href="#about" className={`text-sm font-light transition-colors hover:opacity-80 ${scrolled ? 'text-gray-700' : 'text-white/90'}`}>About</a>
            <a href="#products" className={`text-sm font-light transition-colors hover:opacity-80 ${scrolled ? 'text-gray-700' : 'text-white/90'}`}>Products</a>
            <a href="#features" className={`text-sm font-light transition-colors hover:opacity-80 ${scrolled ? 'text-gray-700' : 'text-white/90'}`}>Features</a>
            <a href="#contact" className={`text-sm font-light transition-colors hover:opacity-80 ${scrolled ? 'text-gray-700' : 'text-white/90'}`}>Contact</a>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <Hero />
      <About />
      <Products />
      <Features />
      <Contact />
      <Footer />
    </div>
  );
}
